<div mat-dialog-title fxLayoutAlign="space-between center">
  <h2>
    {{ (data.estimateTemplate ? 'estimate-templates.dialog.edit-title' : 'estimate-templates.dialog.create-title') | translate }}
  </h2>
</div>
<mat-progress-bar mode="determinate"></mat-progress-bar>

<form [formGroup]="templateForm" (ngSubmit)="onSubmit()">
  <mat-dialog-content>
    <div fxLayout="column">
      <mat-form-field appearance="fill">
        <mat-label>{{ 'common.name' | translate }}</mat-label>
        <input matInput type="text" formControlName="name">
      </mat-form-field>
      <mat-form-field fxFlex>
        <mat-label>{{ 'common.facilities' | translate }}</mat-label>
        <mmx-facility-selector-input
          multiple
          formControlName="facilityIds"
        ></mmx-facility-selector-input>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>{{ 'common.templates' | translate }}</mat-label>
        <mat-select formControlName="templateId">
          <mat-option>
            <ngx-mat-select-search
              [placeholderLabel]="'estimate-templates.list.search' | translate"
              [noEntriesFoundLabel]="'estimate-templates.dialog.no-entries-found' | translate"
              [formControl]="filterTemplateCtrl"
            >
            </ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let template of templates$ | async" [value]="template.id">
            <span>{{ template.name }}</span>
          </mat-option>
        </mat-select>
        <mat-hint>{{ 'estimate-templates.dialog.template-hint' | translate }}</mat-hint>
      </mat-form-field>
      <mmx-charges-table-form
        [chargesFormArray]="chargesFormArray"
        [facilityIds]="templateForm.value.facilityIds"
        [showVisitNumbers]="false"
        (addChargeDiscountControl)="onAddChargeDiscountControl($event)"
        (removeChargeDiscountControl)="onRemoveChargeDiscountControl($event)"
      ></mmx-charges-table-form>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-stroked-button type="button" mat-dialog-close>{{ 'common.cancel' | translate }}</button>

    <button
      mat-flat-button
      color="primary"
      type="submit"
      [disabled]="templateForm.invalid"
    >
      {{ 'common.save' | translate }}
    </button>
  </mat-dialog-actions>
</form>
